import {JsonObject, JsonProperty} from "typescript-json-serializer";
import { MeasurementInfoConfiguration } from "./measurement-info-configuration";
import {MeasurementsInfoSectionConfiguration} from "./measurements-info-section-configuration";


@JsonObject()
export class MeasurementsInfoConfiguration {
    /**
     * Title for the Measurements
     */
    @JsonProperty()
    declare title: string;

    /**
     * Configurations for the measurement block
     */
    @JsonProperty()
    declare measurements: MeasurementInfoConfiguration[];

    /**
     * Information for grouping the measurements in sections
     */
    @JsonProperty()
    declare grouping: MeasurementsInfoGroupTypeConfiguration[];

    constructor() {}
}

@JsonObject()
export class MeasurementsInfoGroupTypeConfiguration {

    /**
     * Base IDs for which this section is applicable
     */
    @JsonProperty()
    declare baseIds: number[];

    /**
     * Base IDs for which this section is applicable
     */
    @JsonProperty()
    declare sections: MeasurementsInfoSectionConfiguration[];

    constructor() {}
}
